import {GameEvent} from '../context/message-event-context'
import {useMessageEvents} from '../context/message-event-context'
import {useEffect} from 'react'

interface UseGameStateProps {
  onGameLoadingStart?: (() => void)[]
  onGameOver?: (() => void)[]
  onGameLoaded?: (() => void)[]
  onLevelUp?: (() => void)[]
}

const useGameState = ({
  onGameLoadingStart = [],
  onGameOver = [],
  onGameLoaded = [],
  onLevelUp = [],
}: UseGameStateProps) => {
  const {registerGameEvent, unregisterGameEvent} = useMessageEvents()

  useEffect(() => {
    const registerEvents = (eventType: GameEvent, callbacks: (() => void)[]) => {
      callbacks.forEach((callback) => registerGameEvent(eventType, callback))
    }
    const unregisterEvents = (eventType: GameEvent, callbacks: (() => void)[]) => {
      callbacks.forEach((callback) => unregisterGameEvent(eventType, callback))
    }

    // Register all callbacks
    registerEvents(GameEvent.Loading, onGameLoadingStart)
    registerEvents(GameEvent.Over, onGameOver)
    registerEvents(GameEvent.Loaded, onGameLoaded)
    registerEvents(GameEvent.LevelUp, onLevelUp)

    // Cleanup function
    return () => {
      unregisterEvents(GameEvent.Loading, onGameLoadingStart)
      unregisterEvents(GameEvent.Over, onGameOver)
      unregisterEvents(GameEvent.Loaded, onGameLoaded)
      unregisterEvents(GameEvent.LevelUp, onLevelUp)
    }
  }, [registerGameEvent, unregisterGameEvent, onGameLoadingStart, onGameOver, onGameLoaded, onLevelUp])
}

export default useGameState
